"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIBackButton = _interopRequireDefault(require("UIComponents/nav/UIBackButton"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ReturnLinkHelper = _interopRequireDefault(require("../utils/ReturnLinkHelper"));

var BackLink =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BackLink, _PureComponent);

  function BackLink() {
    (0, _classCallCheck2.default)(this, BackLink);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BackLink).apply(this, arguments));
  }

  (0, _createClass2.default)(BackLink, [{
    key: "render",
    value: function render() {
      var portalId = _hubspot.default.get();

      var eschref = _ReturnLinkHelper.default.get();

      var message = eschref ? 'back' : 'dashboard';
      var href = eschref || "/dashboard/" + portalId;
      return _react.default.createElement(_UIBackButton.default, {
        onClick: _ReturnLinkHelper.default.clear
      }, _react.default.createElement(_UILink.default, {
        href: href
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "settings-ui-nav." + message
      })));
    }
  }]);
  return BackLink;
}(_react.PureComponent);

exports.default = BackLink;
module.exports = exports.default;